import classNames from "classnames";
import SvgImages from "components/library/SvgImages";
import React, { useEffect, useState } from "react";

const defaultButton: React.FC<{ children: React.ReactNode }> = (props) => <button {...props}>{props.children}</button>;

const filterPages = (visiblePages: number[], totalPages: number) => {
    return visiblePages.filter((page) => page <= totalPages);
};

const getVisiblePages = (page: number, total: number) => {
    if (total < 7) {
        return filterPages([1, 2, 3, 4, 5, 6], total);
    } else {
        if (page % 5 >= 0 && page > 4 && page + 2 < total) {
            return [1, page - 1, page, page + 1, total];
        } else if (page % 5 >= 0 && page > 4 && page + 2 >= total) {
            return [1, total - 3, total - 2, total - 1, total];
        } else {
            return [1, 2, 3, 4, 5, total];
        }
    }
};

export interface PaginationProps {
    pages: number,
    page: number,
    onPageChange: (num: number) => void,
    PageButtonComponent?: React.FC<{
        className: string,
        onClick: () => void,
        disabled?: boolean
    }>
}

const Pagination = (props: PaginationProps) => {
    const [state, setState] = useState({
        visiblePages: getVisiblePages(0, props.pages)
    });
    useEffect(() => {
        setState({ visiblePages: getVisiblePages(0, props.pages) });
    }, [props.pages]);

    const changePage = (page: number) => {
        const activePage = props.page + 1;

        if (page === activePage) {
            return;
        }

        const visiblePages = getVisiblePages(page, props.pages);

        setState({
            visiblePages: filterPages(visiblePages, props.pages)
        });

        props.onPageChange(page - 1);
    };

    const { PageButtonComponent = defaultButton } = props;
    const { visiblePages } = state;
    const activePage = props.page + 1;

    return (
        <div data-testid="pagination" className={classNames("Table__pagination", { "Table__empty": !visiblePages?.length })}>
            <div className="Table__prevPageWrapper pr-2">
                <PageButtonComponent
                    className="Table__pageButton"
                    onClick={() => {
                        if (activePage === 1) return;
                        changePage(activePage - 1);
                    }}
                    disabled={activePage === 1}
                >
                    <SvgImages imgKey="paginationLeft" />
                </PageButtonComponent>
            </div>
            <div className="Table__visiblePagesWrapper">
                {visiblePages.map((page, index, array) => {
                    return (
                        <PageButtonComponent key={page} className={activePage === page ? "Table__pageButton Table__pageButton--active" : "Table__pageButton"} onClick={changePage.bind(null, page)}>
                            {array[index - 1] + 2 < page ? `...${page}` : page}
                        </PageButtonComponent>
                    );
                })}
            </div>
            <div className={classNames("Table__nextPageWrapper", { "pl-2": visiblePages?.length > 6 })}>
                <PageButtonComponent
                    className="Table__pageButton"
                    onClick={() => {
                        if (activePage === props.pages) return;
                        changePage(activePage + 1);
                    }}
                    disabled={activePage === props.pages}
                >
                    <SvgImages imgKey="paginationRight" />
                </PageButtonComponent>
            </div>
        </div>
    );
};

export default Pagination;
